import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AddScheduleAbsenceRequestDto, ScheduleAbsenceDto } from '@core/models/scheduling/schedule-absence.dto';
import { SchedulingDictionaryResponseModel } from '@core/models/scheduling/scheduling-dictionary.response.dto';
import { SchedulingRequest } from '@core/models/scheduling/scheduling.request';
import { map, Observable } from 'rxjs';
import { DomainService } from '../domain.service';


@Injectable({
  providedIn: 'root'
})
export class SchedulingNativeService {
  private _apiUrl: string = '';

  constructor(private readonly http: HttpClient,
    private _domainService: DomainService,
  ) {
    this._domainService.apiUrl$.subscribe((apiUrl: string) => {
      this._apiUrl = apiUrl;
    });
  }


  getSchedulingDictionaries(params: { clientId: number }): Observable<SchedulingDictionaryResponseModel> {
    return this.http.get<SchedulingDictionaryResponseModel>(`${this._apiUrl}scheduling/dictionary/${params.clientId}?format=json`);
  }

  getAbsencesForObjects(params: SchedulingRequest): Observable<ScheduleAbsenceDto[]> {
    return this.http.post<ScheduleAbsenceDto[]>(`${this._apiUrl}scheduling/forplanner?format=json`, params)
      .pipe(map(scheduleList => scheduleList.map(scheduleAbsence => ({
        ...scheduleAbsence,
        DateStart: new Date(scheduleAbsence.DateStart),
        DateEnd: new Date(scheduleAbsence.DateEnd)
      }))));
  }

  addAbsenceForObject(params: AddScheduleAbsenceRequestDto): Observable<ScheduleAbsenceDto> {
    return this.http.put<ScheduleAbsenceDto>(`${this._apiUrl}scheduling/?format=json`, params)
      .pipe(map(scheduleAbsence => ({
        ...scheduleAbsence,
        DateStart: new Date(scheduleAbsence.DateStart),
        DateEnd: new Date(scheduleAbsence.DateEnd)
      })));
  }
}


